import { ApisauceInstance } from 'apisauce';

export type GridExportParams = {
  api: ApisauceInstance;
  name: string;
  data_type: string;
  filters: FilterInput[];
  date_scope: DateRangeInput;
  sort_by: GridSortField[];
  include_fields: { label: string; field: string }[];
  totals_query: string;
  totals_fields: GridAggregateField[];
  baseView: FleetOps.BaseView;
  // When provided, the export is delivered by email rather than surfaced in-app.
  send_email?: boolean;
  // Firebase UIDs to email the export to (max 50). When present, forces email delivery.
  recipient_user_ids?: string[];
  // File naming convention. 'default' appends the date range to the name;
  // 'driverBonus' uses the name only. Omitted means 'default'.
  name_format?: 'default' | 'driverBonus';
};

const exportGrid = ({
  api,
  name,
  data_type,
  filters,
  date_scope,
  sort_by,
  include_fields,
  totals_query,
  totals_fields,
  send_email,
  recipient_user_ids,
  name_format,
}: GridExportParams) =>
  api.post<{ status?: 'ok'; exportDocumentId: string }>('/v1/enqueue_export', {
    name,
    data_type,
    filters,
    date_scope,
    sort_by,
    include_fields,
    totals_fields,
    totals_query,
    ...(send_email !== undefined ? { send_email } : {}),
    ...(recipient_user_ids !== undefined ? { recipient_user_ids } : {}),
    ...(name_format !== undefined ? { name_format } : {}),
  });

export default exportGrid;
